const statusConfig = {
  HSNEW: "HS_NEW",
  HSINPRG: "HS_INPRG",
  HSDCW: "HS_DCW",
  HSDCL: "HS_DCL",
  DRNEW: "DR_NEW",
  DRINPRG: "DR_INPRG",
  DRINREV: "DR_INREV",
  DRCMPLT: "DR_CMPLT",
  DRAPVD: "DR_APVD",
  DRREOPEN: "DR_REOPEN",
  DRPEND: "DR_PEND",
  DRCUSTAPVD: "DR_CUST_APVD",
  DRCUSTREJ: "DR_CUST_REJ",
  LEGNEW: "LEG_NEW",
  LEGINPRG: "LEG_INPRG",
  LEGINPRCS: "LEG_INPRCS",
  LEGVLDT: "LEG_VLDT",
  LEGREV: "LEG_REV",
  LEGCMPLT: "LEG_CMPLT",
  LEGCUSTREV: "LEG_CUST_REV",
  LEGCUSTAPVD: "LEG_CUST_APVD",
  LEGCUSTREJ: "LEG_CUST_REJ",
  LEGSIGPEND:"LEG_SIG_PEND",
  FINNEW: "FIN_NEW",
  FININPRG: "FIN_INPRG",
  FINREV: "FIN_REV",
  FINCMPLT: "FIN_CMPLT",
  RMACTIVE: "RM_ACTIVE",
  RMPJTACTIVE:"RMPJT_ACTIVE",
  RMPEND: "RM_PEND",
  RMPJTCMPLT: "RM_CMPLT",
  RMREJ: "RM_REJ",
  RMWAVCMPLT: "RM_WAV_CMPLT",
  RMNEW: "RM_NEW",
  RMINPRG: "RM_INPRG",
  RMREOPEN: "RM_REOPEN",
  RMREV: "RM_REV",
  RMPRTL: "RM_PRTL",
  RMCMPLT: "RM_CMPLT",
  RMAPVD: "RM_APVD",
  DEMANDNEW: "DEMAND_NEW",
  DEMANDINPRG: "DEMAND_INPRG",
  DEMANDCMPLT: "DEMAND_CMPLT",
  DEMAND_PRELIMINARY: "preliminary_demand_pipe",
  DEMAND_OTHER: "other_demand_pipe",
  DEMAND_PROJECT: "project_demand_pipe",
  SCOPEDNEW: "SCOPED_NEW",
  SCOPEDINPRG:"SCOPED_INPRG",
  SCOPEDCMLPT:"SCOPED_CMPLT",
  DEMANDAPVD:"DEMAND_APVD",
  DEMANDREJ:"DEMAND_REJ",
  SCOPED:"Scoped",
  QUALIFIED:"Qualified",
  DISCOVERy:"Discovery",

  //status for screens
  SCR_LEGNEW: "New",
  SCR_LEGINPRG: "In-progress",
  SCR_LEGREV: "Review",
  SCR_LEGCMPLT: "Completed",
  SCR_LEGCUSTREV: "Customer Review",
  SCR_LEGCUSTAPVD: "Customer Approved",
  SCR_LEGCUSTREJ: "Customer Rejected",

  //inab
  INABNEW:'INAB_NEW',
  INABAPRV:'INAB_APPROVED',
  INABCMPLT:'INAB_COMPLETED',
  INABREJ:'INAB_REJECTED',
  INABPRJFLT:'wavicle_projects',

  //deal lost
  DEAL_LOST:'DEAL_LOST',
  LEG_DEAL_LOST:'LEG_DEAL_LOST',
  DR_DEAL_LOST:'DR_DEAL_LOST',
  DEMAND_LOST:'DEMAND_LOST',
  RM_LOST:'RM_LOST',

  CLOSED_LOST:'closed lost',
};

export default statusConfig;
